



























































import { Vue, Component, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import api from 'src/assets/api/gql'
import SessionCreate from 'src/graphql/session/SessionCreate.gql'
import StudentGroupsList from 'src/graphql/student_group/StudentGroupsList.gql'
import { StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class SessionMenuButtonAdd extends Vue {
  loading = false
  attendeeCount = 0
  groups: StudentGroup[] = []

  @Ref()
  readonly dialog!: DialogFullscreen

  get item () {
    return store.state.presenter.item
  }

  get me () {
    return store.state.person
  }

  async add () {
    if (!this.item.courseId) {
      await this.create(null, null)
    } else {
      this.dialog.show()
      const path = this.item.path.split('.')
      const parentId = path[path.length - 2]
      const { data: { studentGroups, students } } = await api.query({
        query: StudentGroupsList,
        variables: {
          courseId: +parentId
        }
      })
      if (studentGroups ) {
        this.groups = studentGroups.nodes as StudentGroup[]
      }
      if (students) {
        this.attendeeCount = students.totalCount
      }
    }
  }

  async create (studentPublic: boolean | null, studentGroupId: number | null) {
    this.dialog.hide()
    this.loading = true
    const { data: { createSession } } = await api.mutate({
      query: SessionCreate,
      variables: {
        session: {
          topicId: this.item.id,
          studentPublic,
          studentGroupId
        }
      }
    })
    this.loading = false
    if (createSession && createSession.session) {
      this.$router.replace('/presenter/session/' + createSession.session.id)
    }
  }
}
